// 通用模块
const modal = weex.requireModule('modal')
const navigator = weex.requireModule('navigator')
const animation = weex.requireModule('animation')

// 私有模块
var bridgeModule = weex.requireModule('bridgeModule')
import Storage from './storage'

const global = {
  storage: Storage,
  /**
   *吐司信息
   * @param {string} msg 文本信息
   * @param {number} [duration=1.5]
   * @param {*} bgStyle
   */
  toast(msg, duration = 1.5, bgStyle) {
    if (typeof msg !== 'string') {
      msg = JSON.stringify(msg)
    }
    try {
      if (bgStyle) {
        bridgeModule.toast({
          message: msg,
          duration: duration || 1.5,
          bgStyle: bgStyle
        })
      } else {
        bridgeModule.toast({
          message: msg,
          duration: duration || 1.5
        })
      }
    } catch (ex) {
      modal.toast({
        message: msg || '',
        duration: duration
      })
    }
  },

  /**
   * 弹出警告
   * @param msg {string} 提示文本
   * @param callback {function} 点击确定后回调函数
   * @param option {object} 参数
   * @param option.okTitle {string} 确定按钮文本
   */
  alert(msg, callback, option) {
    var okTitle = '确定'
    if (option) {
      if (option.okTitle) okTitle = option.okTitle
    }
    if (typeof msg !== 'string') {
      msg = JSON.stringify(msg)
    }
    modal.alert(
      {
        message: msg || '',
        duration: 1,
        okTitle: okTitle
      },
      value => {
        callback && callback(value)
      }
    )
  },
  /**
   * 弹出确认框
   * @param msg {string} 提示文本
   * @param callback {function} 点击确定/取消后回调函数
   * @param option {object} 参数
   * @param option.okTitle {string} 确定按钮文本
   * @param option.cancelTitle {string} 取消按钮文本
   */
  confirm(msg, callback, option) {
    let okTitle = '确定'
    let cancelTitle = '取消'
    if (option) {
      if (option.okTitle) okTitle = option.okTitle
      if (option.cancelTitle) cancelTitle = option.cancelTitle
    }

    modal.confirm(
      {
        message: msg || '',
        duration: 0.4,
        okTitle: okTitle,
        cancelTitle: cancelTitle
      },
      value => {
        callback && callback(value)
      }
    )
  },

  /**
   * 显示操作成功
   * @method showSuccess
   * @param {object} params 参数
   * @param {string} params.title 显示文本
   */
  showSuccess(params) {
    var options = { title: '操作成功' }
    if (typeof params === 'string') {
      options.title = params
    }
    if (typeof params === 'object') {
      options = Object.assign(options, params)
    }
    try {
      var _this = global
      _this.toast(options.title)
    } catch (e) {}
  },

  /**
   * 显示操作失败
   * @method showError
   * @param {object} params 参数
   * @param {string} params.title 显示文本
   */
  showError(params) {
    var options = { title: '操作失败' }
    if (typeof params === 'string') {
      options.title = params
    }
    if (typeof params === 'object') {
      options = Object.assign(options, params)
    }
    try {
      var _this = global
      _this.toast(options.title)
    } catch (e) {}
  },

  /**
   * 显示一个组件（可设置动画）
   * @param params
   * @param callback
   */
  show(params, callback) {
    var el = params.id
    if (!el) {
      return
    }
    var duration = params.duration
    var transform = params.transform || 'translate(0, 0)'
    var transformOrigin = params.transformOrigin || 'center center'
    var timingFunction = params.timingFunction || 'ease'

    animation.transition(
      el,
      {
        styles: {
          opacity: '1',
          transform: transform,
          transformOrigin: transformOrigin
        },
        duration: duration || 0,
        timingFunction: timingFunction,
        delay: 0
      },
      () => {
        callback && callback()
      }
    )
  },

  /**
   * 隐藏一个组件(可设置动画)
   * @param params
   * @param callback
   */
  hide(params, callback) {
    var el = params.id
    if (!el) {
      return
    }
    var duration = params.duration
    var transform = params.transform || 'translate(0, 0)'
    var transformOrigin = params.transformOrigin || 'center center'
    var timingFunction = params.timingFunction || 'ease'
    animation.transition(
      el,
      {
        styles: {
          opacity: '0',
          transform: transform,
          transformOrigin: transformOrigin
        },
        duration: duration || 0,
        timingFunction: timingFunction,
        delay: 0
      },
      () => {
        callback && callback()
      }
    )
  },

  /**
   * 获取当前上下文路径
   * @return {string} 当前上下文路径
   */
  getContextPath() {
    var url = weex.config.bundleUrl
    if (url.indexOf('?') > 0) {
      url = url.substring(0, url.indexOf('?'))
    }
    url = url
      .split('/')
      .slice(0, -1)
      .join('/')
    return url
  },

  /**
   * 加载一个新的页面(bundleJS)
   * @method push
   * @param url {string} bundle js 地址
   * @param params {object} 传递的参数
   */
  push(url, params, callback) {
    var paramsStr = ''
    var _this = global
    if (params) {
      for (var key in params) {
        paramsStr += key + '=' + encodeURIComponent(params[key]) + '&'
      }
    }
    if (url.indexOf('?') < 0 && paramsStr != '') {
      url += '?'
    }
    url += paramsStr
    // dolphin平台中使用navigatorEx,playground中使用navigator
    try {
      if (url.indexOf('http') == 0 || url.indexOf('file') == 0) {
        navigator.push(
          {
            url: url,
            animated: 'true'
          },
          callback
        )
      } else {
        url = _this.getContextPath() + '/' + url
        navigator.push(
          {
            url: url,
            animated: 'true'
          },
          callback
        )
      }
    } catch (ex) {
      console.error(ex)
    }
  },

  /**
   * 返回上个页面
   * @method pop
   * @param options {object} 配置参数
   * @param options.animated {bool} 是否需要过渡动画，默认true
   * @param options.level {int} 返回层级，默认1
   * @param callback {function} 回调函数
   */
  pop(callback, options) {
    options = options || {}
    navigator.pop(
      {
        animated: options.animated || 'true',
        level: options.level || 1
      },
      callback
    )
  },

  /**
   * 重新加载当前页面
   * @param {fn} callback 成功回调
   * @param {fn} callbackFail 失败回调
   */
  reload(callback, callbackFail) {
    var params = {}
    bridgeModule.reload(
      params,
      resData => {
        if (callback) callback(resData)
      },
      error => {
        if (callbackFail) callbackFail(error)
      }
    )
  }
}

export default global



// WEBPACK FOOTER //
// ./packages/core/index.js